<div class="grid-container margin-top">
  <div class="grid-x">
    @if (request != null) {
      <div class="cell large-3 medium-3 small-6 bold padding-right text-align-right">
        Date Requested:
      </div>
      <div class="cell large-3 medium-3 small-6 padding-left">
        {{request?.dateRequested | date: 'MM/dd/yyyy' }}
      </div>
      <div class="cell large-3 medium-3 small-6 bold padding-right text-align-right">
        Requested By:
      </div>
      <div class="cell large-3 medium-3 small-6 padding-left">
        {{request?.requestedByName}}
      </div>
      <div class="cell large-12 medium-12 small-12 margin-bottom">
        <ag-grid-angular class="data-grid " [gridOptions]="gridOptions" [rowData]="data" aria-label="Approve Bulk Well Update"></ag-grid-angular>
      </div>
      <div class="cell large-12 medium-12 small-12 bold">
        Reason for Request:
      </div>
      <div class="cell large-12 medium-12 small-12" [innerHtml]="request?.reasonForRequest">
      </div>
      <div class="cell large-12 medium-12 small-12">
        <h3 class="minor-margin-bottom h6">Original File(s): <help-text [helpText]="fileHelpText"></help-text></h3>
        @for (file of uploadedFiles; track file) {
          <div class="flex">
            <uploaded-file [allowFileDeletion]="false" [file]="file"></uploaded-file>
          </div>
        }
      </div>
    } @else {
      <div class="cell large-12 medium-12 small-12">
        <text-loader [run]="request == null" [interval]="1000" [tickType]="'.'" [text]="'Loading Request'"></text-loader>
      </div>
    }
  </div>
</div>

